// extracted by mini-css-extract-plugin
module.exports = {"selectStudentInvitation":"-Qw1SFYr-grVkfYtXMU53w==","studentArea":"wEfc0E2-2dmXv8cFUud5KA=="};